<template>
  <div>
    <el-drawer
      :visible.sync="drawerState"
      :modal="false">
      <span class="pageHeader title">个人信息</span>
      <div class="card_header">
        <el-avatar  class="avatar" :size="64" shape="square" :src="selfList.headimg"></el-avatar>
        <h3 class="cum_name">{{ selfList.name }}</h3>
      </div>
      <div class="card_main">
        <el-descriptions :column='2' direction="vertical">
          <el-descriptions-item
            :labelStyle="{'font-size':'16px','color':'#999999'}"
            :contentStyle="{'font-size':'16px','color':'#303133','padding-right':'20px'}"
            label="用户名">
            {{ selfList.nickname }}
          </el-descriptions-item>
          <el-descriptions-item
            :labelStyle="{'font-size':'16px','color':'#999999'}"
            :contentStyle="{'font-size':'16px','color':'#303133','padding-right':'20px'}"
            label="手机号">
            {{ selfList.phone }}
          </el-descriptions-item>
          <el-descriptions-item
            :labelStyle="{'font-size':'16px','color':'#999999'}"
            :contentStyle="{'font-size':'16px','color':'#303133','padding-right':'20px'}"
            label="账号">
            {{ selfList.account_name }}
          </el-descriptions-item>
          <!-- <el-descriptions-item
            :labelStyle="{'font-size':'16px','color':'#999999'}"
            :contentStyle="{'font-size':'16px','color':'#303133','padding-right':'20px'}"
            label="状态">
            {{ selfList.state }}
          </el-descriptions-item> -->
          <!-- <el-descriptions-item
            :labelStyle="{'font-size':'16px','color':'#999999'}"
            :contentStyle="{'font-size':'16px','color':'#303133','padding-right':'20px'}"
            label="邮箱地址">
            {{ selfList.email }}
          </el-descriptions-item>
          <el-descriptions-item
            :labelStyle="{'font-size':'16px','color':'#999999'}"
            :contentStyle="{'font-size':'16px','color':'#303133','padding-right':'20px'}"
            label="微信昵称">
            {{ selfList.nickname }}
          </el-descriptions-item>
          <el-descriptions-item
            :labelStyle="{'font-size':'16px','color':'#999999'}"
            :contentStyle="{'font-size':'16px','color':'#303133','padding-right':'20px'}"
            label="部门">
            {{ selfList.departmentName }}
          </el-descriptions-item>
          <el-descriptions-item
            :labelStyle="{'font-size':'16px','color':'#999999'}"
            :contentStyle="{'font-size':'16px','color':'#303133','padding-right':'20px'}"
            label="职位">
            {{ selfList.positionName }}
          </el-descriptions-item>
          <el-descriptions-item
            :labelStyle="{'font-size':'16px','color':'#999999'}"
            :contentStyle="{'font-size':'16px','color':'#303133','padding-right':'20px'}"
            label="客户访问量">
            {{ selfList.visit }}
          </el-descriptions-item>
          <el-descriptions-item
            :labelStyle="{'font-size':'16px','color':'#999999'}"
            :contentStyle="{'font-size':'16px','color':'#303133','padding-right':'20px'}"
            label="新增客户量">
            {{ selfList.increases }}
          </el-descriptions-item>
          <el-descriptions-item
            :labelStyle="{'font-size':'16px','color':'#999999'}"
            :contentStyle="{'font-size':'16px','color':'#303133','padding-right':'20px'}"
            label="意向客户量">
            {{ selfList.intentions }}
          </el-descriptions-item>
          <el-descriptions-item
            :labelStyle="{'font-size':'16px','color':'#999999'}"
            :contentStyle="{'font-size':'16px','color':'#303133','padding-right':'20px'}"
            label="签约客户量">
            {{ selfList.signs }}
          </el-descriptions-item> -->
          <!-- <el-descriptions-item
            :labelStyle="{'font-size':'16px','color':'#999999'}"
            :contentStyle="{'font-size':'16px','color':'#303133','padding-right':'20px'}"
            label="渠道二维码">
            {{ selfList.reviewer }}
          </el-descriptions-item> -->
        </el-descriptions>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { getSelfData } from '@/api/stafflist.js'
export default {
  // props: {
  //   selfList: {
  //     type: Object,
  //     default: _=>{
  //       return 
  //     }
  //   },
  // },
  data() {
    return {
      drawerState: false,
      selfList:""
      // selfList: []
    }
  },
  mounted() {
      this.selfList = JSON.parse(localStorage.getItem('idxi'))
    // this.getSelfData()
  },
  methods: {
    getSelfData() {
      getSelfData().then((res) => {
        if(res && res.status === 200000) {
          this.selfList = res.data ? res.data : []
          const headimg = res.data.headimg
          localStorage.setItem('headimg',headimg)
        }
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.title{
  margin-left: 20px;
}
.card_header{
  position: relative;
  width: 70%;
  height: 200px;
  top: 30px;
  left: 10%;
  .cum_name{
    position: relative;
    top: -70px;
    left: 80px;
  }
}
.card_main{
  width: 90%;
  margin-left: 10%;
  margin-top: -10%;
}
</style>
